<template>
    <b-row>
        <b-col class="text-center">
            <hr/>
            <p>Служба поддержки РО Эко-Сити <b-link href='tel:83472980490'>8 (3472) 980 490</b-link><br />
            Основной сайт <b-link href="https://roecocity.ru">roecocity.ru</b-link></p>
        </b-col>
    </b-row>  
</template>

<script>
export default {
    /*computed: {
        getName() {
            return this.$store.getters.COMPANY.name.full
        }
    }*/
}
</script>

<style>

</style>